<ng-container *ngIf="status !== 'view'">

    <button *ngIf="materialTree.nodesSelectedCounts[node.Id]" mat-icon-button
        matTooltip="{{'se-ui-selector-web_deselect_group' | translate}}" matTooltipPosition="right"
        (click)="treeCommandsHandler.unCheckGroup(node)">
        <mat-icon>library_add_check</mat-icon>
    </button>

    <button *ngIf="!materialTree.nodesSelectedCounts[node.Id]"
        [disabled]="!treeUtils.hasSelectableChildren(node)" mat-icon-button
        matTooltip="{{ 'se-ui-selector-web_select_group' | translate}}" matTooltipPosition="right"
        (click)="treeCommandsHandler.checkGroup(node)" class="filter_all">
        <mat-icon>filter_none</mat-icon>
    </button>
    <!-- {{materialTree.nodesSelectedCounts[node.Id] | json}} -->
</ng-container>
